// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__kfKrx","footer":"styles_footer__12SQk","passCodeTooltip":"styles_passCodeTooltip__QaBkU"};